import Modal from "/WebInterface/new-ui/modules/modal.js";
import Tooltip from "/WebInterface/new-ui/modules/tooltip/tooltip.js";
import {
  generateCustomForm,
  attachCustomFormTools,
} from "/WebInterface/new-ui/modules/custom-form/custom-form.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { getCustomForm } from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import { uploadFormTemplate } from "./template.js";
import store from "/WebInterface/new-ui/store/index.js";
import { validate } from "/WebInterface/new-ui/assets/js/utils/validate.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { postCustomForm } from "/WebInterface/new-ui/assets/js/utils/api/apis.js";

function invoke(method, params) {
  const _parent =
    typeof self.window[method] === "function" ? self.window : parent.window;
  if (_parent[method]) {
    return _parent[method].apply(this, params);
  }
}

export const showCustomUploadFormModal = async ({
  onAfterShow = () => {},
  onSuccess,
  onCancel,
  onPrev,
  onNext,
  uploadFile,
}) => {
  const { customUploadForm } = store;
  let uploadForm = customUploadForm;

  if (!uploadForm) {
    uploadForm = await getCustomForm("uploadForm");
    store.dispatch("setCustomUploadForm", uploadForm);
  }

  const formName = uploadForm?.name;

  const uploadFormAskAgainHideAndUnchecked = invoke(
    "getUserCustomizationValue",
    ["uploadFormAskAgainHideAndUnchecked"]
  );
  const uploadFormAskAgainChecked = invoke("getUserCustomizationValue", [
    "uploadFormAskAgainChecked",
  ]);
  const uploadFormAskAgainHideAndChecked = invoke("getUserCustomizationValue", [
    "uploadFormAskAgainHideAndChecked",
  ]);

  const uploadFormModal = new Modal({
    title: t("uploadDetails"),
    body: uploadFormTemplate({
      uploadFormAskAgainHideAndUnchecked,
      uploadFormAskAgainChecked,
      uploadFormAskAgainHideAndChecked,
    }),
    hasCloseOption: false,
    closable: false,
    uniqueId: "upload-file-form",
    minWidth: "900px",
    minHeight: "700px",
    buttons: [
      {
        label: "cancel",
        close: false,
        classes: ["mr-3", "is-bordered"],
        onClick: () => {
          onCancel(uploadFormModal);
        },
      },
      {
        label: "ok",
        close: false,
        classes: ["mr-3"],
        onClick: () => {
          const doNotShowRemainingFiles =
            (!uploadFormAskAgainHideAndUnchecked &&
              _$("#doNotShowAddFilesCheck").el()?.checked) ||
            uploadFormAskAgainHideAndChecked;

          onSuccess(uploadFormModal, uploadForm, doNotShowRemainingFiles);
        },
      },
    ],
  });

  const formContent = generateCustomForm(uploadForm);
  _$("#uploadFormTemplate #uploadFormContainer").html(formContent);

  attachCustomFormTools(uploadFormModal.root, formName);

  const tooltip = new Tooltip();

  _$(uploadFormModal.root)
    .find("[data-tooltip]")
    .sel()
    .forEach((button) => {
      tooltip.addTooltip({ element: button });
    });

  _$(uploadFormModal.root).find(".upload-file-name").text(uploadFile?.name);

  if (onPrev)
    _$(uploadFormModal.root)
      .find(".upload-form-prev-btn")
      .on("click", () => {
        onPrev({ uploadFormModal });
      });

  if (onNext)
    _$(uploadFormModal.root)
      .find(".upload-form-next-btn")
      .on("click", () => {
        onNext({ uploadFormModal });
      });

  onAfterShow({ uploadFormModal });
};

export const updateCustomUploadFormModal = (
  uploadFormModal,
  uploadFile,
  customFormData
) => {
  _$(uploadFormModal.root).find(".upload-file-name").text(uploadFile?.name);

  if (customFormData) {
    updateCustomForm(customFormData, uploadFormModal);
  } else {
    const { customUploadForm } = store;
    const formName = customUploadForm?.name;
    const formContent = generateCustomForm(customUploadForm);
    _$("#uploadFormTemplate #uploadFormContainer").html(formContent);

    attachCustomFormTools(uploadFormModal.root, formName);
  }
};

export const updateCustomForm = (customFormData, uploadFormModal) => {
  for (const [key, value] of Object.entries(customFormData)) {
    const input = _$(uploadFormModal.root).find(`[name='${key}']`).el();

    if (input?.type === "radio") {
      _$(uploadFormModal.root)
        .find(`[name="${key}"][value="${value}"]`)
        .el().checked = true;

      continue;
    }

    if (input?.type === "checkbox") {
      input.checked = true;
      continue;
    }

    _$(uploadFormModal.root).find(`[name='${key}']`).val(value);
  }

  const firstInput = uploadFormModal.root.querySelector("input");

  if (firstInput) {
    firstInput.focus();
  }
};

export const isCustomUploadFormAvailable = () => {
  return store?.customUploadForm;
};

export const showCommonUploadForm = async ({
  formValues,
  onSuccess,
  onCancel,
}) => {
  const { customCommonUploadForm } = store;
  let uploadForm = customCommonUploadForm?.formDetails;

  if (!uploadForm) {
    uploadForm = await getCustomForm("commonUploadForm");
    store.dispatch("setCustomCommonUploadForm", uploadForm);
  }

  const uploadFormModal = new Modal({
    title: t("uploadDetails"),
    body: `<div class="is-flex-grow-1" id="commonUploadFormContainer"></div>`,
    movable: true,
    hasCloseOption: false,
    animate: false,
    minWidth: "700px",
    minHeight: "700px",
    closable: false,
    buttons: [
      {
        label: "cancel",
        close: false,
        classes: ["mr-3", "is-bordered"],
        onClick: () => {
          onCancel(uploadFormModal);
        },
      },
      {
        label: "ok",
        close: false,
        classes: ["mr-3"],
        onClick: () => {
          const validateFields = validate(uploadFormModal.root, false);

          if (validateFields.length === 0) {
            const data = utils.serializeInputs(uploadFormModal.root);

            postCustomForm({
              ...data,
              meta_form_name: uploadForm?.name,
              command: "discard",
              meta_UploadFormId: uploadForm?.id,
              meta_UploadFormName: uploadForm?.name,
              meta_unique_upload_id: utils.getUId(),
            })
              .catch((error) => {
                console.log(error);
              })
              .finally(() => {
                onSuccess({
                  ...data,
                  meta_form_name: uploadForm?.name,
                  meta_UploadFormId: uploadForm?.id,
                  meta_UploadFormName: uploadForm?.name,
                  meta_unique_upload_id: utils.getUId(),
                });
                uploadFormModal.hide(true);
              });
          }
        },
      },
    ],
  });

  const formContent = generateCustomForm(uploadForm);
  const formName = uploadForm?.name;
  _$("#commonUploadFormContainer").html(formContent);

  attachCustomFormTools(uploadFormModal.root, formName);

  if (formValues) {
    updateCustomForm(formValues, uploadFormModal);
  }
};
